<script>
  import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "crossFourEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        directionList: [
          {
            value: 'topToBottom',
            name: '从上到下'
          },
          {
            value: 'bottomToTop',
            name: '从下到上'
          },
          {
            value: 'leftToRight',
            name: '从左到右'
          },
          {
            value: 'rightToLeft',
            name: '从右到左'
          },
        ],
        formList: [
          'CrossFourForm',
        ],
        ruleList: {
        }
      }
    },
    computed: {
      specificForms() {
        return (
          <div class="specificForms">
              <el-collapse-item class="specificForm" title="相贯管道效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="CrossFourForm" props={{model: this.newSettings}} ref="CrossFourForm" rules={this.ruleList} label-style={this.formLabelStyle}>
                      <el-form-item label="管道颜色" prop="background" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.background,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"管道颜色"
                          }}}{...{on: {
                            'input': val=>{
                              this.newSettings.background = val;
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>
          </div>
        )
      }
    },
  }
</script>

<style lang="less">
  .crossTwoEditor {
    .singleSelect {
      height: 30px;
      line-height: 30px;
      width: 100%;
      border-radius: 5px;
      padding: 0 10px;
    }
  }
</style>

